import moment from 'moment'

// Exceção deliberada ao gate do design-system (moment → aawzDate): aqui é
// moment LOCAL de propósito. aawzDate formata em UTC (utils/dates/aawz-date/
// format.js usa getUTC*) e deslocaria o dia civil perto da meia-noite BRT;
// além disso a máscara precisa de paridade byte a byte com o month-picker
// FilterDates (filter-dates.vue, MONTHS), que também gera as opções com
// moment. NÃO trocar por aawzDate — reintroduz o bug de meio do mês.
//
// Janela padrão da Visão Geral nas máscaras de fim de mês do FilterDates (o
// month-picker só emite o último dia do mês). Após a normalização do
// filtrosFormatados, o request efetivo vira "início do mês de 6 meses atrás
// até o fim do mês corrente". Nascer no "dia corrente" (ex: 28/07) vazava
// data de meio do mês para a API de opções de filtro, desalinhada do período
// fechado enviado aos endpoints de dados.
const MESES_JANELA_PADRAO = 6

// Fim de mês via startOf + 1 mês - 1 dia: com moment local o endOf('month')
// também seria seguro; o idioma é mantido por consistência com o
// filtrosFormatados da view-overview, onde a formatação em UTC do aawzDate
// torna o endOf de fato inseguro.
export const fimDoMes = (base) =>
  base.clone().startOf('month').add(1, 'months').subtract(1, 'days')

export const periodoPadraoVisaoGeral = () => ({
  data_inicio: fimDoMes(
    moment().subtract(MESES_JANELA_PADRAO, 'months')
  ).format('DD/MM/YYYY'),
  data_final: fimDoMes(moment()).format('DD/MM/YYYY'),
})

// Chave ordenável AAAAMMDD por componentes de string — data civil não passa
// por Date/parse (sem risco de timezone).
const chaveOrdenavel = (data) => {
  const [dia, mes, ano] = data.split('/')
  return `${ano}${mes}${dia}`
}

// Garante data_inicio <= data_final (swap quando invertido). Estado invertido
// já aconteceu em dev: o typo do handleFilterApply descartava a metade
// inicial da seleção do FilterDates e o localStorage preservava o par
// invertido entre sessões (payload real capturado: data_inicial=01-04-2026
// com data_final=30-06-2025).
export const ordenarPeriodo = (filtros) => {
  const { data_inicio, data_final } = filtros
  if (!data_inicio || !data_final) return filtros
  if (chaveOrdenavel(data_final) >= chaveOrdenavel(data_inicio)) return filtros
  return { ...filtros, data_inicio: data_final, data_final: data_inicio }
}
